import React from "react";
import { BrowserRouter as Router, Route, Routes, Switch } from "react-router-dom";
//componentes para eliminar snackbar
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close"; //estilos
import "./assets/css/base.css";
import { ThemeProvider } from "@material-ui/core/styles";
import theme, { palette } from "./configurations/styles/theme";
import notificationStyles from "./configurations/styles/notifications";
import { makeStyles } from "@material-ui/core/styles";
//componetes del sistema
import Administracion from "./views/administración/home";
import Login from "./views/Login";
import Register from "./views/registro";
import Footer from "./widgets/Footer";
import NotFound from "./views/NotFound";
//redux
import store from "./redux/store";
import { Provider } from "react-redux";

//notificaciones
import { SnackbarProvider } from "notistack";
import { SnackbarUtilsConfigurator } from "utils/SnackbarUtils";
import Company from "views/administración/company";
import SistemaContable from "views/sistemaContable";
import ModuleHub from "views/ModuleHub";

const useStyles = makeStyles({
  ...notificationStyles,
});

function App() {
  const classes = useStyles();

  // configuracion de las notificaciones del sistema
  const notistackRef = React.createRef();
  const onClickDismiss = (key) => () => {
    notistackRef.current.closeSnackbar(key);
  };

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Provider store={store}>
          <SnackbarProvider
            maxSnack={15}
            classes={{
              variantSuccess: classes.successNotification,
              variantError: classes.error,
              variantWarning: classes.warning,
              variantInfo: classes.info,
            }}
            ref={notistackRef}
            action={(key) => (
              <IconButton onClick={onClickDismiss(key)}>
                <CloseIcon
                  style={{ color: palette.error.main }}
                  fontSize="small"
                />
              </IconButton>
            )}
          >
            <SnackbarUtilsConfigurator />
            <Routes>
              <Route  path="/" element={<Login/>} />
              <Route  path="/login" element={<Login/>} />
              <Route  path="/registro" element={<Register/>} />
              <Route  path="/modulos" element={<ModuleHub/>} />
              <Route  path="/facturacion" element={<Administracion/>} />
              <Route  path="/sistema-contable" element={<SistemaContable/>} />
              {<Route path="/company" element={<Company/>} />}
              <Route element={<NotFound/>} />
            </Routes>
          </SnackbarProvider>
          <Footer />
        </Provider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
